<template>
  <div class="app">
		<div class="row">
			<div class="col-md-12">
				<div class="box">
					<div class="box-header with-border">
						<h3 class="box-title">Мои бронирования</h3>
					</div>
					<div class="box-body">
						<p v-if="items.length < 1">У вас пока нет ни одного бронирования :(</p>
						<table v-if="items.length > 0" class="table no-margin">
							<thead>
								<tr>
									<th>ID бронирования</th>
									<th>ID сделки</th>
									<th>Места</th>
									<th>Статус</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, key) in items" v-bind:key="key" >
									<td>{{ item.id }}</td>
									<td>{{ item.dealId }}</td>
									<td>
										<ul class="seats-list">
											<li v-for="(seat, key2) in item.seats" v-bind:key="key2" @click="seatPerson(seat.id)"><span :class="'label label-' + getCategoryClass(seat.category)">{{ seat.seat }}</span></li>
										</ul>
									</td>
									<td><span :class="'label label-' + getStatusClass(item.status)">{{ getStatusText(item.status) }}</span></td>
									<td>
										<dropdown menu-right>
											<btn class="dropdown-toggle">Действие <span class="caret"></span></btn>
											<template slot="dropdown">
												<li><a role="button" @click="emailModalHandler(item.id)">Отправить билеты</a></li>
												<li><a role="button" @click="removeHandler(item.id, key)">Удалить</a></li>
											</template>
										</dropdown>
									</td>
								</tr>
								</tbody>
							</table>
					</div>
					<div class="box-footer">
						<router-link to="/" class="btn btn-sm btn-default btn-flat pull-right">Вернуться к схеме бронирования</router-link>
					</div>
				</div>
			</div>
		</div>
		<modal v-model="open" title="Данные о клиенте для билетов" @hide="modal" ref="modal" id="modalReservation">
			<div slot="footer">
        <btn @click="open=false">Отмена</btn>
        <btn v-if="!loading" type="info" @click="person">OK</btn>
      </div>
			<p style="color: #ff0000">Пожалуйста, отнесись к следующим поля максимально серьезно, без всяких смехуечков! Указаное ФИО будет отображаться на билетах!</p>
			<form v-if="!loading">
				<alert type="danger" v-if="alert" dismissible @dismissed="alert = false">{{ alertText }}</alert>
				<div class="form-group" :class="errors.firstName === true ? 'has-error' : ''">
					<label for="firstName">Имя</label>
					<input class="form-control" id="firstName" v-model="form.firstName" required />
				</div>
				<div class="form-group" :class="errors.lastName === true ? 'has-error' : ''">
					<label for="lastName">Фамилия</label>
					<input class="form-control" id="lastName" v-model="form.lastName" required />
				</div>
				<div class="form-group" :class="errors.middleName === true ? 'has-error' : ''">
					<label for="middleName">Отчество</label>
					<input class="form-control" id="middleName" v-model="form.middleName" required />
				</div>
			</form>
			<div v-if="loading" class="loading"></div>
    </modal>

		<modal v-model="emailModalShow" title="Отправка билетов" @hide="modal2" ref="modal">
			<div slot="footer">
        <btn @click="emailModalShow=false">Отмена</btn>
        <btn v-if="!loading" type="info" @click="sendEmail" :disabled="sendDisabled">OK</btn>
      </div>
			<alert type="danger" v-if="alert" dismissible @dismissed="alert = false">{{ alertText }}</alert>
			<form v-if="!loading">
				<div class="form-group">
					<label for="email">E-mail</label>
					<textarea class="form-control" id="email" v-model="email" required></textarea>
					<span class="help-block">Необходимо ввести хотя бы один адрес электронной почты. Если их несколько, укажите их через запятую.</span>
				</div>
			</form>
			<div v-if="loading" class="loading"></div>
    </modal>

	</div>
</template>
<script>
export default {
	data: function () {
		return {
			open: false,
			emailModalShow: false,
			alert: false,
			alertText: '',
			items: [],
			loading: true,
			sendDisabled: false,
			form: {
				firstName: '',
				lastName: '',
				middleName: '',
				seatId: null
			},
			email: '',
			reservationId: null,
			errors: []
		}
	},
	mounted: function () {
		this.myReservation()
	},
	methods: {
		myReservation () {
			this.$http.get('https://tip24.ru/event/ajax/my?event_id=' + this.getQueryVariable('id'), {}, {
			}).then(function (response) {
				let data = response.data
				this.items = data
			}, function (response) {
			})
		},
		removeHandler: function (id, key) {
			this.$alert({
				title: 'Подтвердите действие',
				content: 'Вы уверены что хотите отменить бронь? Это действие нельзя будет отменить!'
			}, (msg) => {
				if (msg === 'ok') {
					this.remove(id, key).then((result) => {
						if (result === true) {
							this.items.splice(key, 1)
							this.$notify({
								placement: 'bottom-right',
								content: 'Бронь успешно отменена!'
							})
						}
					})
				}
			})
		},
		person: function () {
			this.errors = []

			Object.keys(this.form).forEach((key) => {
				if (this.form[key] === '' || typeof this.form[key] === 'undefined') {
					this.errors.push(key)
				}
			})

			if (this.errors.length > 0) {
				return false
			}

			this.callPrsonApi().then((result) => {
				if (result === true) {
					this.resetModal()
					this.open = false
					this.$notify({
						placement: 'bottom-right',
						content: 'Данные сохранениы!'
					})
				} else {
					this.open = false
					this.$notify({
						placement: 'bottom-right',
						type: 'danger',
						content: 'Ошибка сервера!'
					})
				}
			})
		},
		remove: function (id) {
			return new Promise((resolve, reject) => {
				this.$http.post('https://tip24.ru/event/ajax/remove', {
					event_id: this.getQueryVariable('id'),
					revision_id: id
				}, {
				}).then(function (response) {
					// let data = response.data
					// this.items = data
					resolve(true)
				}, function (response) {
					reject(new Error('Request failed: ' + response.status))
				})
			})
		},
		callPrsonApi: function () {
			return new Promise((resolve, reject) => {
				this.$http.post('https://tip24.ru/event/ajax/person', {
					seat_id: this.form.seatId,
					first_name: this.form.firstName,
					last_name: this.form.lastName,
					middle_name: this.form.middleName
				}, {
				}).then(function (response) {
					resolve(true)
				}, function (response) {
					// reject(new Error('Request failed: ' + response.status))
					resolve(false)
					// reject(false)
				})
			})
		},
		modal: function (e) {
			if (e === 'cancel' || e === 'dismiss') {
				this.resetModal()
			}
			if (e === 'ok') {
				this.open = true
			}
		},
		modal2: function (e) {
			if (e === 'cancel' || e === 'dismiss') {
				// this.resetModal()
			}
			if (e === 'ok') {
				this.emailModalShow = true
			}
		},
		getStatusClass: function (val) {
			let categories = {
				0: 'info',
				1: 'success'
			}
			return categories[val]
		},
		getStatusText: function (val) {
			let categories = {
				0: 'Не оплачено',
				1: 'Оплачено'
			}
			return categories[val]
		},
		getCategoryClass: function (val) {
			let categories = {
				vip: 'danger',
				business: 'warning',
				standard: 'default'
			}
			return categories[val]
		},
		getCategoryText: function (val) {
			let categories = {
				vip: 'VIP',
				business: 'Бизнес',
				standard: 'Стандарт'
			}
			return categories[val]
		},
		getQueryVariable: function (name) {
			var query = window.location.search.substring(1)
			var vars = query.split('&')
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=')
				if (decodeURIComponent(pair[0]) === name) {
					return decodeURIComponent(pair[1])
				}
			}
		},
		seatPerson: function (id) {
			this.resetModal()
			this.$http.get('https://tip24.ru/event/ajax/get-persone?seat_id=' + id, {}, {
			}).then(function (response) {
				let data = response.data
				this.form.firstName = data.first_name
				this.form.lastName = data.last_name
				this.form.middleName = data.middle_name
			}, function (response) {
			})
			this.form.seatId = id
			this.open = true
			this.loading = false
		},
		emailModalHandler: function (id) {
			this.$http.get('https://tip24.ru/event/ajax/reservation?id=' + id, {}, {
			}).then(function (response) {
				this.loading = false
				this.emailModalShow = true
				this.reservationId = id
				let data = response.data
				this.email = data.data.email
			}, function (response) {
			})
		},
		sendEmail: function () {
			if (this.email === '') {
				return false
			}

			this.toggleSendDisabled()

			this.$http.post('https://tip24.ru/event/ajax/send-email', {
				id: this.reservationId,
				email: this.email
			}, {
			}).then(function (response) {
				this.toggleSendDisabled()
				this.alertText = ''
				this.alert = false
				this.email = ''
				this.emailModalShow = false
				this.loading = true
			}, function (response) {
				this.toggleSendDisabled()
				this.alert = true
				this.alertText = 'Вы указали ФИО не всех участников!'
			})
		},
		resetModal: function () {
			this.form.firstName = ''
			this.form.lastName = ''
			this.form.middleName = ''
			this.errors = {}
			this.loading = true
			this.alert = false
			this.alertText = ''
		},
		toggleSeatInfo: function (val) {
			if (this.popover === val) {
				this.popover = ''
			} else {
				this.popover = val
			}
		},
		toggleSendDisabled: function () {
			this.sendDisabled = !this.sendDisabled
		}
	}
}
</script>
<style>
ul.seats-list {
	padding: 0;
	margin: 0;
	list-style: none;
}
ul.seats-list li {
	position: relative;
	display: inline-block;
	margin-right: 5px;
	cursor: pointer;
}
.label {
	text-transform: lowercase;
	font-size: 12px;
	font-weight: bold;
}

.seats-list .label {
	text-transform: uppercase;
}

.loading::after {
	position: absolute;
	left: calc(50% - (1.5em / 2));
	top: calc(50% - (1.5em / 2));
	position: absolute!important;
}

.loading {
	position: relative;
	width: 32px;
	height: 32px;
	margin: 20px auto;
}

.loading::after {
	-webkit-animation: spinAround .5s infinite linear;
	animation: spinAround .5s infinite linear;
	border: 2px solid #dbdbdb;
	border-radius: 290486px;
	border-right-color: transparent;
	border-top-color: transparent;
	content: "";
	display: block;
	height: 1.5em;
	position: relative;
	width: 1.5em;
}

@-webkit-keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
  }
}
@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/My.vue